import d2Admin from "@/plugin/d2admin";
import VxeUITable, { VxeUI } from 'vxe-table';
import VxeUIAll from 'vxe-pc-ui';
import excel from "@d2-projects/vue-table-export";
import horizontalScroll from 'el-table-horizontal-scroll';

// 引入样式
import 'vxe-table/lib/style.css';
import 'vxe-table/lib/index.css';
import 'vxe-pc-ui/lib/style.css';

export default function setupPlugins(Vue) {
    Vue.use(VxeUIAll);
    Vue.use(VxeUITable);
    Vue.use(d2Admin);
    Vue.use(excel);
    Vue.use(horizontalScroll);
}
